import * as React from "react";
import dayjs from "dayjs";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useEffect } from "react";

let BasicDateTimePicker = (props) => {
  const [value, setValue] = React.useState(dayjs("2019-01-01T18:54"));

  useEffect(() => {
    let { expired_at } = props.user;
    setValue(expired_at);
  }, [props.user]);

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <p className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-6">
          Expiry Date
        </p>
        <DateTimePicker
          className="w-full"
          renderInput={(props) => <TextField {...props} />}
          value={value}
          onChange={(newValue) => {
            setValue(newValue);
            props.getData(newValue);

          }}
          inputFormat="YYYY/MM/DD hh:mm a"
      
        />
      </LocalizationProvider>
    </div>
  );
};

export default BasicDateTimePicker;
